/**
 * Created by Abner Sui on 08/21/2019
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { WidgetsModule } from '../../widgets/widgets.module';
import { TaskKanbanComponent } from '../../components/work-flow/kanban/task-kanban.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { KanbanTaskCardComponent } from '../../components/work-flow/kanban-card/kanban-task-card.component';
import { TaskDetailModule } from '../../components/work-flow/task-detail/task-detail.module';
import { KanbanInstanceCardComponent } from '../../components/work-flow/kanban-card/kanban-instance-card.component';
import { AgGridModule } from 'ag-grid-angular';
import { WorkflowKanbanScreenComponent } from './kanban/workflow-kanban-screen.component';
import { InstanceViewComponent } from '../../components/work-flow/instance-view/instance-view.component';
import { FileInfoAggridComponent } from '../../components/work-flow/file-info-aggrid/file-info-aggrid.component';
import { FileInfoModule } from '../../components/work-flow/file-info/file-info.module';
import { WorkflowDialogComponent } from './workflow-dialog/workflow-dialog.component';
import { WorkflowDialogService } from './workflow-dialog/workflow-dialog.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { WorkflowConfigComponent } from './workflow-config/workflow-config.component';
import { WorkflowConfigSubChromeComponent } from './workflow-config/workflow-config-sub-chrome/workflow-config-sub-chrome.component';
import { DiagramModule } from '../../widgets/diagram/diagram.module';
import { NumberInfoAggridComponent } from '../../components/work-flow/number-info-aggrid/numbere-info-aggrid.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { CustomGroupRowInnerRenderer } from '../../components/work-flow/grid-group-row-inner-render/custom-group-row-inner-renderer.component';
import { TaskDefinitionModule } from '../../components/work-flow/task-definition/task-definition.module';
import { TemplateConfigurationModule } from '../../components/template-configuration/template-configuration.module';
import { TaskPostActionModule } from '../../components/work-flow/task-post-action/task-post-action.module';
import { TaskSettingWrapperModule } from '../../components/work-flow/task-definition-settings/task-setting-wrapper.module';
import { WorkflowTriggerSettingsModule } from '../../components/work-flow/workflow-trigger-settings/workflow-trigger-settings.module';
import { TaskGridKanbanModule } from '../../components/work-flow/task-grid-kanban/task-grid-kanban.module';
import { TaskViewComponent } from './../../components/work-flow/task-view/task-view.component';
import { WorkflowKanbanWrapperComponent } from './workflow-kanban-wrapper/workflow-kanban-wrapper.component';

@NgModule({
    imports: [
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // ag-grid
        AgGridModule,
        // kendo
        ButtonsModule,
        InputsModule,
        DateInputsModule,
        DialogsModule,
        DropDownButtonModule,
        DropDownsModule,
        TooltipModule,
        // project
        WidgetsModule,
        TaskDetailModule,
        FileInfoModule,
        DiagramModule,
        TaskDefinitionModule,
        TemplateConfigurationModule,
        TaskPostActionModule,
        TaskSettingWrapperModule,
        WorkflowTriggerSettingsModule,
        TaskGridKanbanModule
    ],
    declarations: [
        TaskKanbanComponent,
        KanbanTaskCardComponent,
        KanbanInstanceCardComponent,
        CustomGroupRowInnerRenderer,
        WorkflowKanbanScreenComponent,
        InstanceViewComponent,
        FileInfoAggridComponent,
        NumberInfoAggridComponent,
        WorkflowDialogComponent,
        WorkflowConfigComponent,
        WorkflowConfigSubChromeComponent,
        TaskViewComponent,
        WorkflowKanbanWrapperComponent
    ],
    providers: [
        CurrencyPipe,
        WorkflowDialogService,
    ],
    exports: [
        WorkflowDialogComponent,
        WorkflowKanbanScreenComponent,
    ]
})
export class WorkflowModule { }
